// GraphQL queries for booking
import { BOOKING_FRAGMENT } from '../fragments/booking';
import { QUERY_PARAMS_FRAGMENT } from '../fragments/common';

// Query bookings in shop
export const QUERY_BOOKING_IN_SHOP = `
  query queryBookingInShop($input: QueryBookingInShopInput!) {
    queryBookingInShop(input: $input) {
      bookings {
        ${BOOKING_FRAGMENT}
      }
      queryParams {
        total
      }
    }
  }
`;

// Get booking count by date range
export const BOOKING_COUNT_BY_DATE_RANGE = `
  query bookingCountByDateRange($input: BookingCountByDateRangeInput!) {
    bookingCountByDateRange(input: $input) {
      data {
        date
        count
      }
      total
    }
  }
`;

// Count bookings
export const COUNT_BOOKINGS = `
  query countBookings($input: CountBookingsInput!) {
    countBookings(input: $input) {
      count
    }
  }
`;